import styled from 'styled-components'
import { COLORS } from 'theme'
import { Table } from 'antd'
import { FONT } from 'theme/font'
export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background: ${COLORS.WHITE};
  position: sticky;
  top: 0;
  z-index: 1;
  padding-bottom: 10px;
`
export const BodyStyleDiv = styled.div`
  margin-top:20px;
  padding: 8px 15px;
`
export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const FilterSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: nowrap;
`

export const FilterGroup = styled.div`
  flex: 0 0 20%;
`

export const CheckboxContainer = styled.div`
  flex: 0 0 20%;
  display: flex;
  align-items: center;
`

export const ActionRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 20px;
`
export const StyledTable = styled(Table)`
  padding: ${props => (props.padding ? props.padding : '0px')};
  width: ${props => (props.width ? props.width : '')};
  .ant-table-thead {
    height: 60px;
  }

  .ant-table-tbody > tr:hover > td {
    background-color: ${props => (props.hover ? '#ffffff' : '#fafafa')};
  }

  .ant-table-tbody > tr > td {
    background-color: ${props => (props.headerColor ? '#FAFAFB' : '#ffffff')};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
    content: none;
  }
  .ant-table-container table > thead > tr:first-child th:first-child,
  .ant-table-container table > tbody > tr td:first-child {
    padding-left: ${props => (props.paddingLeft ? '0px' : '25px')};
  }
  .ant-table-container table > thead > tr:first-child th:last-child,
  .ant-table-container table > tbody > tr td:last-child {
    padding-right: 25px;
  }
  tr {
    th {
      background: ${props =>
        props.headerColor ? 'white' : COLORS.PRIMARY_GREY_T_98};
      font-style: normal;

      font-weight: ${props => (props.fontWeight ? '600' : FONT.FW_500)};

      font-size: ${props => (props.fontSize ? '15px' : FONT.F_XS)};
      line-height: 1.125em;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: ${COLORS.GREY_T_30};

      ::before {
        height: 0px;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    justify-content: center;
  }
  .ant-radio-inner {
    background-color: transparent;
  }

  .ant-table-expanded-row td {
    padding: ${props =>
      props?.expandedRowPadding ? props?.expandedRowPadding : '0'} !important;
  }

  .ant-table th.ant-table-column-has-sorters.ant-table-column-sort:hover {
    border-bottom: 2px solid transparent !important;
  }
`
